// Helper function to get the hour and minute from a date
const getTime = (date: Date) => ({
  hour: date.getHours(),
  minute: date.getMinutes()
});

// Check if a slot is in the morning
export const isMorning = (date: Date): boolean => {
  const { hour, minute } = getTime(date);
  return (hour >= 8 && hour < 11) || (hour === 11 && minute === 0);
};

// Check if a slot is in the mid-day
export const isMidday = (date: Date): boolean => {
  const { hour } = getTime(date);
  return hour >= 11 && hour < 15;
};

// Check if a slot is in the afternoon/evening
export const isEvening = (date: Date): boolean => {
  const { hour } = getTime(date);
  return hour >= 15 && hour < 20;
};
